import { useUser } from 'controllers/contexts/user';
import {
  FlowCampaignView,
  FlowCampaignViewTarget,
  resolveFlowCampaignView,
} from '../utils/flowViewPath';
import { useShowSdpocCampaigns } from './useShowSdpocCampaigns';

type ResolvableTarget = Omit<
  FlowCampaignViewTarget,
  'isAdmin' | 'hasCampaignsSurface'
>;

export type FlowCampaignViewResolver = (
  target: ResolvableTarget,
) => FlowCampaignView;

/**
 * Binds `resolveFlowCampaignView` to the current user's admin + Shopper
 * Campaigns surface eligibility, so callers don't each re-derive `isAdmin`
 * (`useUser().user?.is_admin`) and `hasCampaignsSurface`
 * (`useShowSdpocCampaigns()`) — any future change to how either is computed
 * then only needs updating here instead of at every call site.
 */
export const useFlowCampaignViewResolver = (): FlowCampaignViewResolver => {
  const { user } = useUser();
  const isAdmin = user?.is_admin ?? false;
  const hasCampaignsSurface = useShowSdpocCampaigns();

  return (target: ResolvableTarget): FlowCampaignView =>
    resolveFlowCampaignView({ ...target, isAdmin, hasCampaignsSurface });
};
